import { Campo } from './ui';
import { TIPO_VISITA_ETIQUETA } from '../lib/formato';
import type { TipoVisita, TipoLugar } from '../lib/tipos';

export interface DatosVisitaForm {
  visitType: TipoVisita | null;
  venueType: TipoLugar | null;
  venueOther: string;
  productsToDiscuss: string;
}

/** Campos mínimos V3-A; el selector de franjas mantiene el comportamiento actual. */
export function DatosVisita({ valor, onCambio, localidad }: {
  valor: DatosVisitaForm;
  onCambio: (patch: Partial<DatosVisitaForm>) => void;
  localidad?: string;
}) {
  return <>
    <Campo etiqueta="Tipo de visita">
      <select aria-label="Tipo de visita" value={valor.visitType ?? ''} onChange={(e) => {
        const type = e.target.value as TipoVisita || null;
        onCambio({ visitType: type, ...(type === 'CLIENT_AT_HQ' ? { venueType: 'SP_HQ' as const } : {}) });
      }}>
        <option value="">Seleccione el tipo</option>
        {Object.entries(TIPO_VISITA_ETIQUETA).map(([value, label]) =>
          <option key={value} value={value}>{label}</option>)}
      </select>
    </Campo>
    <Campo etiqueta="Lugar de celebración" ayuda={valor.venueType === 'CLIENT' ? localidad : undefined}>
      <select aria-label="Tipo de visita" value={valor.visitType === 'CLIENT_AT_HQ' ? 'SP_HQ' : valor.venueType ?? ''}
        disabled={valor.visitType === 'CLIENT_AT_HQ'}
        onChange={(e) => onCambio({ venueType: e.target.value as TipoLugar || null })}>
        <option value="">Seleccione el lugar</option>
        <option value="CLIENT">Cliente</option>
        <option value="SP_HQ">Sede Salvador Pinar</option>
        <option value="OTHER">Otro</option>
      </select>
    </Campo>
    {valor.venueType === 'OTHER' && valor.visitType !== 'CLIENT_AT_HQ' &&
      <Campo etiqueta="Indique el lugar">
        <input type="text" aria-label="Indique el lugar" value={valor.venueOther} onChange={(e) => onCambio({ venueOther: e.target.value })} />
      </Campo>}
    {valor.visitType === 'NO_PRODUCT' &&
      <Campo etiqueta="Productos a comentar">
        <textarea aria-label="Productos a comentar" value={valor.productsToDiscuss}
          onChange={(e) => onCambio({ productsToDiscuss: e.target.value })} />
      </Campo>}
  </>;
}
